class LocationPickerManager {
  constructor(broadcastChannelName = "locationBroadcast") {
    this.cartUpdates = {};
    this.notEnoughItems = [];
    this.oldLocationData = {};
    this.ecom_data = document.querySelector(`[name="ecom-data"]`);
    
    this.locationBroadcast = new ecomBroadcast(broadcastChannelName);
    this.storageKey = "spar_location";
    this.init();
  }

  init() {
    this.loadLocationData();
    this.setupEventListeners();
    this.cartResponse();
    
    window.addEventListener("load", ()=>{
      const data = JSON.parse(localStorage.getItem(this.storageKey)) || null;
      if (!data) return;
      
      this.updateSelectedVariantLocation(data.locationId.toLowerCase());
    });
    
  }

  openLocationPicker() {
    const locationPopup = document
      .querySelector("[location-picker-container]")
      .cloneNode(true);
    locationPopup.hidden = false;
    document.body.insertAdjacentElement("beforeend", locationPopup);
  }

  closeAllOpenPickers() {
    const openPickers = document.querySelectorAll("body > [location-picker-container]");
    openPickers.forEach(picker => picker.remove());
  }

  loadLocationData(cameFromBroadcast = false) {
    const data = JSON.parse(localStorage.getItem(this.storageKey)) || null;

    if(!data && this.ecom_data.dataset.template == "cart") {
      // this.openLocationPicker();
    }
    if (!data) return;

    this.oldLocationData = data;
    this.setLocationData(data.locationId, data.locationText, cameFromBroadcast);
  }

  setLocationData(locationId, locationText, onlySet = false) {
    const locationSelector = document.querySelector("[location-selector]");
    locationSelector.setAttribute("location-id", locationId);
    locationSelector.setAttribute("location-name", locationText);
    locationSelector.textContent = locationText;

    localStorage.setItem(this.storageKey, JSON.stringify({
      locationId: locationId.toLowerCase(),
      locationText
    }));

    if(onlySet) {
      document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));
      return;
    }

    this.updateCartWhenShopChange();

    // Update CSS to hide items from other locations
    const styleContainer = document.querySelector("[hide-other-location-inputs]");
    if (styleContainer) {
      styleContainer.innerHTML = `
        .variant-item:not([variant-location*="${locationId.toLowerCase()}"]) {
          display: none;
        }
        
        .card__content button[data-sold-out-message][locations*="${locationId.toLowerCase()}"] {
            display: block !important;
        }
        
        .card__content button[data-sold-out-message][locations*="${locationId.toLowerCase()}"] + quantity-input {
            display: none;
        }
        
        .card__content:not(:has(button[data-sold-out-message][locations*="${locationId.toLowerCase()}"])) .card__badge {
            display: none;
        }
        city-dropdown option[data-location]:not([data-location="${locationId.toLowerCase()}"]) {
          display: none;
        }
        city-dropdown .pickup-location:not([value="${locationId.toLowerCase()}"]) {
            display: none;
        }
        `;
    }

    this.updateSelectedVariantLocation(locationId.toLowerCase());

    // send event location:changed
    window.dispatchEvent(new CustomEvent("locaton:changed", {bubbles: true}));
  }

  updateSelectedVariantLocation(locationId) {
    // update variants
    document.querySelectorAll(`variant-selects fieldset[option-name='location'] [data-option="${locationId.toLowerCase()}"]`)
    .forEach(elem => {
      if (!elem.selected) {
        elem.selected = true;
        elem.click();
      }
    });
  } 
  
  async cartResponse () {
    const cartResponse = await fetch("/cart?view=ajax").then(res => res.json());
    window.localStorage.setItem('ecom_cart_items', JSON.stringify(cartResponse));
  }

  async updateCartWhenShopChange(cameFromBroadcast = false) {
    document.dispatchEvent(new CustomEvent("add-to-cart:disable", {bubbles: true}));

    try {
      const cartResponse = await fetch("/cart?view=ajax").then(res => res.json());
      const locationData = JSON.parse(localStorage.getItem(this.storageKey)) || null;

      if(!locationData) {
        document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));
        return this.openLocationPicker();
      }
      
      const updates = {};
      const notEnoughItems = [];
      
      window.localStorage.setItem('ecom_cart_items', JSON.stringify(cartResponse));
      document.dispatchEvent(new CustomEvent("ecom_cart_items:update", {bubbles: true}));

      for (let item of cartResponse.items) {
        console.log(`item.current_variant_location ${item.current_variant_location} locationData.locationId.toLowerCase() ${locationData.locationId.toLowerCase()}`)
        if (item.current_variant_location === locationData.locationId.toLowerCase()) continue;

        const isDiscountNinja = item.current_variant_properties.some(property =>
          property[0].toLowerCase().includes("discountninja")
        );

        if(isDiscountNinja) continue;

        for (let variant of item.product_variants) {
          console.log(variant, item)
          if (variant.variant_location === locationData.locationId.toLowerCase() &&
             variant.option_2 == item.option_2 &&
             variant.option_3 == item.option_3 
             ) {
            // updates[variant.variant_id] = item.current_quantity;
            // updates[item.current_variant] = 0;

            updates[item.current_variant] = 0;
            
            if(variant.variant_quantity >= item.current_quantity) {
              updates[variant.variant_id] = {"id":variant.variant_id, "quantity":item.current_quantity, "properties": item.current_variant_properties};
            } else {
              updates[variant.variant_id] = variant.variant_quantity;
              
              const notEnoughItem = {};
              notEnoughItem['title'] = item.current_product_title + "<br>" +item.current_variant_title;
              notEnoughItem['req_quantity'] = item.current_quantity;
              notEnoughItem['available_quantity'] = variant.variant_quantity;
              notEnoughItem['image'] = item.current_variant_image;

              notEnoughItems.push(notEnoughItem);
            }
          }
        }
      }

      console.log({notEnoughItems, updates})

      if (Object.keys(updates).length === 0) {
        console.log("nothing to change");
        await this.updateCartLocation();
        document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));
        return;
      }
      
      this.cartUpdates = updates;
      this.notEnoughItems = notEnoughItems;
      
      if(notEnoughItems.length > 0) {
        console.log("notEnoughItems are there");
        document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));
        return this.showNotEnoughItems();
      }

      //if there is no not enough items, then request cart to update
      this.updateCartVariantsReq();

    } catch (err) {
      console.error("Error updating cart:", err);
    }
    document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));

  }

  async updateCartLocation() {
    const locationData = JSON.parse(localStorage.getItem(this.storageKey)) || null;
    await fetch("/cart.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { "Store Location": locationData.locationId.toUpperCase() }
      })
    });
  }

  async updateCartVariantsReq() {
    await this.updateCartLocation();
    
    const removeItems = Object.fromEntries(
        Object.entries(this.cartUpdates).filter(([key, value]) => value === 0)
    );
    
    const addItems =  Object.entries(this.cartUpdates)
    .filter(([_, value]) => {
      if (typeof value === 'number') return value !== 0;
      if (typeof value === 'object' && value !== null) return true;
      return false;
    })
    .map(([key, value]) => {
      if (typeof value === 'number') {
        return { id: Number(key), quantity: value };
      } else if (typeof value === 'object') {
        return {
          id: value.id,
          quantity: value.quantity,
          properties: value.properties ? Object.fromEntries(value.properties) : {}
        };
      }
    }).filter(Boolean);

    console.log({addItems, "cartUpdates": this.cartUpdates});
    
    try {
      document.dispatchEvent(new CustomEvent("add-to-cart:disable", {bubbles: true}));
      const clearReq = await fetch("/cart/clear");
      const clearRes = await clearReq.text();
      
      await new Promise(resolve=>setTimeout(resolve, 1200));

      if(addItems.length > 0) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: addItems })
        });
      } else {
        deleteAllCookies();
      }

      this.locationBroadcast.sendMessage({ type: "cartUpdated", runFunction: true });
      
      const ecom_data = document.querySelector(`[name="ecom-data"]`);
      if(ecom_data.dataset.template == "cart"){
        window.location.reload();
      }
    }catch(e){
      console.log(e);
    }
    document.dispatchEvent(new CustomEvent("add-to-cart:enable", {bubbles: true}));
  }
  
  async confirmCartChange(){
    //show loading screen
    const notEnoughItemsPopup = document.querySelector(`[not-enough-item-popup]`);
    notEnoughItemsPopup.hidden = true;

    const cartItemChange = document.querySelector(`[cart-item-changing]`);
    cartItemChange.hidden = false;

    await this.updateCartVariantsReq();
    await new Promise(resolve => setTimeout(resolve, 5000));
    
    cartItemChange.hidden = true;

    // reload the page because of the not enough line items
    window.location.reload();
  }

  showNotEnoughItems() {
    const notEnoughItemsPopup = document.querySelector(`[not-enough-item-popup]`);
    const itemContainer = notEnoughItemsPopup.querySelector(`[not-enough-items] tbody`);

    let html = "";
    for(let item of this.notEnoughItems) {
      console.log(item)
      html += `
      <tr>
        <td><img src="${item.image}" class="item-image"></td>
        <td>${item.title}</td>
        <td>${item.req_quantity}</td>
        <td>${item.available_quantity}</td>
      </tr>
      `;
    }
    itemContainer.innerHTML = html;
    notEnoughItemsPopup.hidden = false;
  }

  closeNotEnoughPopup(loadPreviousData = false) {
    if(loadPreviousData) {
      this.setLocationData(this.oldLocationData.locationId, this.oldLocationData.locationText, true);
    }

    document.querySelectorAll("[not-enough-item-popup]").forEach(elem=> elem.hidden = true)
  }
  
  setupEventListeners() {
    // Open picker when location selector is clicked
    document.addEventListener("click", e => {
      const target = e.target.closest("[location-selector]");
      if (!target) return;

      this.openLocationPicker();
      this.locationBroadcast.sendMessage({ type: "locationOpen", runFunction: true });
    });

    // Open picker via custom event
    window.addEventListener("change-location", (event) => {
      this.openLocationPicker();
      this.locationBroadcast.sendMessage({ type: "locationOpen", runFunction: true });
    });

    // Close not enough item changer
    document.addEventListener("click", e => {
      const target = e.target.closest("[not-enough-item-close]");
      if (!target) return;

      this.closeNotEnoughPopup(true);
    });
    
    // Close picker on button click
    document.addEventListener("click", e => {
      const target = e.target.closest("[close-location-picker]");
      if (!target) return;

      this.closeAllOpenPickers();
      this.locationBroadcast.sendMessage({ type: "locationClose", runFunction: true });
    });

    //confirm item change
    document.addEventListener("click", e => {
      const target = e.target.closest("[confirm-item-change]");
      if (!target) return;

      this.confirmCartChange()
    });

    // Handle location selection
    document.addEventListener("click", e => {
      const target = e.target.closest("[location]");
      if (!target) return;

      const locationId = target.getAttribute("value");
      const locationText = target.textContent;

      this.setLocationData(locationId, locationText);
      this.closeAllOpenPickers();
      this.locationBroadcast.sendMessage({ type: "locationClose", runFunction: true });
    });
  }
}

// Initialize the manager
const locationPickerManager = new LocationPickerManager();